// extracted by mini-css-extract-plugin
export default {"viewWishListButton":"ViewMyWishListButton_viewWishListButton__vyLWc"};